interface Props {
  [key: string]: any
}

export default function VolumeOnIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 99 98" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M64.1052 34.5612C66.0016 36.4571 67.506 38.7081 68.5323 41.1855C69.5587 43.6629 70.087 46.3183 70.087 48.9999C70.087 51.6815 69.5587 54.3368 68.5323 56.8142C67.506 59.2916 66.0016 61.5426 64.1052 63.4385M75.6528 23.0135C79.0654 26.4261 81.7725 30.4774 83.6194 34.9361C85.4662 39.3949 86.4168 44.1737 86.4168 48.9999C86.4168 53.826 85.4662 58.6048 83.6194 63.0636C81.7725 67.5223 79.0654 71.5736 75.6528 74.9862M23.476 61.2499H16.9998C15.9169 61.2499 14.8783 60.8197 14.1125 60.0539C13.3467 59.2881 12.9165 58.2495 12.9165 57.1665V40.8332C12.9165 39.7502 13.3467 38.7116 14.1125 37.9458C14.8783 37.1801 15.9169 36.7499 16.9998 36.7499H23.476L42.6963 17.5296C45.2688 14.9571 49.6665 16.7783 49.6665 20.4165V77.5832C49.6665 81.2214 45.2688 83.0426 42.6963 80.4701L23.476 61.2499Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="8.16667"
      />
    </svg>
  )
}
